export type GameStatus = "live" | "in-dev";
export type GameCategory = "crash" | "dice" | "table" | "mines" | "physics" | "puzzle";

export interface GameMeta {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  roundSeconds: number;
  rtpPercent: number;
  category: GameCategory;
  status: GameStatus;
  accent: "cyan" | "gold" | "red" | "green";
}

export const GAMES: GameMeta[] = [
  {
    slug: "vault-breaker",
    name: "Vault Breaker",
    tagline: "Five locks. Thirty seconds. One exit.",
    description:
      "A multiplier climbs from 1.00× while five vault locks crack at random intervals. Cash out at any moment — or watch the vault seal.",
    roundSeconds: 30,
    rtpPercent: 99.0,
    category: "crash",
    status: "live",
    accent: "gold",
  },
  {
    slug: "pressure-plate",
    name: "Pressure Plate",
    tagline: "Walk the vault floor. Don't trip the alarm.",
    description:
      "A 5×5 vault floor with hidden pressure plates. Pick a tile — safe ones step the multiplier up, mines silent-alarm and seal the round. Set 1 to 24 mines to dial risk vs payout. Cash out any time.",
    roundSeconds: 0,
    // 5% house edge (vs 1% on the crash game). Mines payout structure makes
    // doubling at pick 3 a coin-flip at 1% edge, so we run tighter to keep
    // the game honestly difficult.
    rtpPercent: 95.0,
    category: "mines",
    status: "live",
    accent: "gold",
  },
  {
    slug: "cipher-crack",
    name: "Cipher Crack",
    tagline: "Crack the 4-digit safe in five guesses.",
    description:
      "A provably-fair Mastermind under a 30-second clock. The server commits a 4-digit code; you have four attempts to crack it. Each guess returns gold pegs (right digit, right slot) and silver pegs (right digit, wrong slot). Crack on attempt 1 = 20×, attempt 4 = 1.3×. Pure deduction under time pressure.",
    roundSeconds: 30,
    rtpPercent: 99.0,
    category: "puzzle",
    status: "live",
    accent: "gold",
  },
  {
    slug: "cold-deck",
    name: "Cold Deck",
    tagline: "Blackjack-adjacent with a sealed deck.",
    description:
      "A 90-second table original. The deck is committed before the shuffle — every card reveal is verifiable. Cash out before the dealer's turn or press and double the multiplier.",
    roundSeconds: 90,
    rtpPercent: 99.2,
    category: "table",
    status: "in-dev",
    accent: "cyan",
  },
  {
    slug: "split-six",
    name: "Split Six",
    tagline: "High-variance dice with six doors.",
    description:
      "Six doors, one roll. Payout tree rolls forward as each door closes. Max 300× in a single hand. Designed to be the loudest game on the lobby.",
    roundSeconds: 20,
    rtpPercent: 98.5,
    category: "dice",
    status: "in-dev",
    accent: "red",
  },
  {
    slug: "red-door",
    name: "Red Door",
    tagline: "Fifteen seconds of nerve.",
    description:
      "A six-chamber roulette of will. Each second, a door is armed. Cash out before the chamber rotates to red. Skill meets prayer.",
    roundSeconds: 15,
    rtpPercent: 99.0,
    category: "crash",
    status: "in-dev",
    accent: "cyan",
  },
];

export function getGame(slug: string): GameMeta | undefined {
  return GAMES.find((g) => g.slug === slug);
}
